/**
 * The current brand theme's version of one of RiskLo's palette colors, for
 * places that need a literal color (SVG chart strokes can't use CSS variables).
 * Falls back to the original when no brand theme is applied.
 */
export function themeColor(hex) {
  if (typeof document === 'undefined' || !hex) return hex;
  const v = getComputedStyle(document.documentElement).getPropertyValue(`--bt-${String(hex).replace('#', '').toLowerCase()}`).trim();
  return v || hex;
}
